import { stringify } from 'query-string';

const vendorPathGenerator = ({
  plaque,
  searchQuery,
  vendorId,
}: {
  vendorId?: string | null;
  plaque?: string | null;
  searchQuery?: string;
}): string => {
  return `/vendor/${plaque || ''}?${stringify({
    ...(searchQuery && { query: searchQuery }),
    baseFilter: JSON.stringify({ vendors: [vendorId ?? ''] }),
  })}`;
};

export default vendorPathGenerator;
